// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-content-wrapper-contentWrapper-styles__contentWrapper {
  padding: 48px 50px 48px 50px;
}

.src-content-wrapper-contentWrapper-styles__welcome {
  display: flex;
  justify-content: center;
  font-size: 24px;
  color: #00bf4b;
  color: var(--cps-color-primary);
  font-weight: 500;
}

.src-content-wrapper-contentWrapper-styles__card {
  width: 42rem;
  border: 1px solid #f3f3f3 !important;
  position: relative;
}

.src-content-wrapper-contentWrapper-styles__fullPage {
  height: 100%;
  width: 100%;
  position: absolute;
  background-color: #f4f5f8;
  background-size: cover;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.src-content-wrapper-contentWrapper-styles__upgradeSuccessMsg {
  max-width: 40rem;
  margin-bottom: 5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/content-wrapper/contentWrapper.styles.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,MAAM;EACN,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[".contentWrapper {\n  padding: 48px 50px 48px 50px;\n}\n\n.welcome {\n  display: flex;\n  justify-content: center;\n  font-size: 24px;\n  color: #00bf4b;\n  color: var(--cps-color-primary);\n  font-weight: 500;\n}\n\n.card {\n  width: 42rem;\n  border: 1px solid #f3f3f3 !important;\n  position: relative;\n}\n\n.fullPage {\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  background-color: #f4f5f8;\n  background-size: cover;\n  top: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.upgradeSuccessMsg {\n  max-width: 40rem;\n  margin-bottom: 5rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentWrapper": `src-content-wrapper-contentWrapper-styles__contentWrapper`,
	"welcome": `src-content-wrapper-contentWrapper-styles__welcome`,
	"card": `src-content-wrapper-contentWrapper-styles__card`,
	"fullPage": `src-content-wrapper-contentWrapper-styles__fullPage`,
	"upgradeSuccessMsg": `src-content-wrapper-contentWrapper-styles__upgradeSuccessMsg`
};
export default ___CSS_LOADER_EXPORT___;
